import { useEffect } from "react";
import { X, ListChecks, Calendar, Phone, AlertTriangle, Bell, CreditCard, ArrowDownCircle, ShoppingBag, FileText, Users, StickyNote } from "lucide-react";

/**
 * Bottom sheet "Aggiungi" — slide-up dal basso con grid di scorciatoie.
 * Chiusura: overlay click, tasto X, o swipe-down (handle bar).
 */
export default function QuickAddSheet({ open, onClose, onNavigate }) {
  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onEsc);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEsc);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  const items = [
    { id: "task",     label: "Ciclo",     icon: ListChecks,       to: "/tasks?new=1",       color: "#95BAEF" },
    { id: "event",    label: "Evento",    icon: Calendar,         to: "/agenda?new=event",  color: "#A9C8F1" },
    { id: "call",     label: "Call",      icon: Phone,            to: "/tasks?new=1&type=call", color: "#C3DAF4" },
    { id: "deadline", label: "Scadenza",  icon: AlertTriangle,    to: "/tasks?new=1&type=deadline", color: "#F5C24A" },
    { id: "reminder", label: "Promemoria",icon: Bell,             to: "/tasks?new=1&type=reminder", color: "#95BAEF" },
    { id: "payment",  label: "Pagamento", icon: CreditCard,       to: "/tasks?new=1&type=payment",  color: "#A9C8F1" },
    { id: "income",   label: "Entrata",   icon: ArrowDownCircle,  to: "/tasks?new=1&type=income",   color: "#C3DAF4" },
    { id: "purchase", label: "Acquisto",  icon: ShoppingBag,      to: "/tasks?new=1&type=purchase", color: "#F5C24A" },
    { id: "document", label: "Documento", icon: FileText,         to: "/documenti?upload=1",        color: "#95BAEF" },
    { id: "lead",     label: "Lead PV",   icon: Users,            to: "/tasks?new=1&type=lead",     color: "#A9C8F1" },
    { id: "note",     label: "Nota",      icon: StickyNote,       to: "/tasks?new=1&type=note",     color: "#C3DAF4" },
  ];

  return (
    <div
      className="fixed inset-0 z-50 flex items-end md:hidden"
      role="dialog"
      aria-modal="true"
      aria-label="Aggiungi rapidamente"
      data-testid="quick-add-sheet"
    >
      <div className="absolute inset-0 bg-black/40" onClick={onClose} data-testid="quick-add-overlay" />
      <div
        className="relative w-full bg-white rounded-t-2xl shadow-2xl animate-slide-up"
        style={{
          maxHeight: "80vh",
          paddingBottom: "env(safe-area-inset-bottom)",
          animation: "slideUpMobileSheet 0.22s ease-out",
        }}
      >
        <style>{`
          @keyframes slideUpMobileSheet {
            from { transform: translateY(100%); opacity: 0.5; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}</style>
        {/* Handle bar */}
        <div className="flex justify-center py-2" role="none">
          <span className="h-1 w-10 rounded-full bg-gray-300" aria-hidden="true" />
        </div>
        {/* Header */}
        <div className="flex items-center justify-between px-5 pb-2">
          <h2 className="font-display text-lg font-semibold" style={{ color: "var(--pxos-text-dark)" }}>
            Aggiungi
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 -mr-1.5 rounded-full hover:bg-gray-100"
            aria-label="Chiudi pannello"
            data-testid="quick-add-close"
          >
            <X size={20} style={{ color: "var(--pxos-text-dark)" }} />
          </button>
        </div>
        {/* Grid */}
        <div className="grid grid-cols-3 gap-3 px-5 pb-6 pt-2 overflow-y-auto" style={{ maxHeight: "65vh" }}>
          {items.map((it) => (
            <button
              key={it.id}
              type="button"
              onClick={() => onNavigate(it.to)}
              className="flex flex-col items-center gap-2 rounded-xl border p-3 transition active:scale-95 hover:bg-gray-50"
              style={{ borderColor: "#E5E7EB", background: "white", minHeight: "88px" }}
              data-testid={`quick-add-${it.id}`}
            >
              <div
                className="h-10 w-10 rounded-full grid place-items-center"
                style={{ background: it.color + "33" }}
              >
                <it.icon size={20} style={{ color: it.color }} />
              </div>
              <span className="text-xs font-medium text-center leading-tight" style={{ color: "var(--pxos-text-dark)" }}>
                {it.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
